// const connection = io.connect(`${location.protocol}//${location.hostname}:4000`);
const connection = "OK";

module.exports = {
	connection
}
